import { Component, Input } from '@angular/core';
import { Cta, CtaModule } from '@rogers/cdk/assembled/cta';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, CtaModule],
  selector: 'ucx-js-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent {
  @Input() currentPlan = [];
  @Input() newPlan = [];
  @Input() offerTitle = '';
  features: Cta = {
    copy: '',
    variant: 'tertiary',
    alt: 'view all features',
    icon: 'arrow-right',
    alignIcon: 'right',
    type: 'button',
  };
  @Input() set buttonCopy(value: string) {
    if (this.features && value) {
      this.features.copy = value;
    }
  }

  @Input() viewFeatures;

  onViewFeatures() {
    this.viewFeatures();
  }

  styleObject(row: number) {
    return { 'grid-row': '' + row };
  }
}
